import axios from "src/utils/axios";

// const getFilterOptions = async ({ by }) => {
//   const response = await axios.get(`/getfilters?by=${by}`);
//   return response.data;
// };

const getFilterOptions = ({ by }) => axios.get(`/getfilters?by=${by}`);

export { getFilterOptions };
